import moment from 'moment-timezone';
import { emptyText } from '@mummssoftware/utils/constants';
import { order, mapTag } from '../containers/Context/constants';

export const formatMMDDYY = (n: any) => {
  if (n && n.noteddatetime && n.sitetimezone && n.id !== -1) {
    return moment
      .utc(n.visitdatetime || n.noteddatetime)
      .tz(n.sitetimezone)
      .format('MM-DD-YY');
  }
  return '';
};

export const formathhmm = (n: any) => {
  if (n && n.noteddatetime && n.sitetimezone && n.id !== -1) {
    return moment
      .utc(n.visitdatetime || n.noteddatetime)
      .tz(n.sitetimezone)
      .format('hh:mmA');
  }
  return '';
};

// @note does not check for OTH and Non Orders Discharge : transfer, expired ...
// NOT USED
export const checkOrderPresent = (entity: any) => {
  let newEntity: any = {};

  Object.keys(entity).forEach((key) => {
    const newKey = mapTag[key];
    newEntity = { ...newEntity, [newKey]: entity[key] };
  });

  return newEntity[order];
};

// if note is not empty an order was filled
export const checkIsOrder = (note: mumms.progressNote | null) =>
  note && note.note && note.note.trim() !== emptyText;

const specialCharacters = [
  ['<', '\u2329'],
  ['>', '\u232a'],
  // ex: ['$', '']
];

// @note we apply parse from 'html-react-parser' on notes before rendering them in the UI.
// @note This was added after we switched to an rtf editor in Unsigned Verbals tab of cert-app.
export const removeSpecialCharacters = (note: string) =>
  specialCharacters.reduce((seed, [c, r]) => seed.replaceAll(c, r), note);

export const filterProgressNote = (
  pn: mumms.patientProgressNoteDTO,
): mumms.patientProgressNoteDTO => ({
  ...pn,
  note: removeSpecialCharacters(pn.note),
});
